module.exports = __webpack_public_path__ + "img/design@2x.a18ad92.webp";